// Feedback Keys

export const IterableHintKeys = [
    'hintCorruptImage',
    'hintCvNoBarcodeFound',
    'hintImageSmallerThanMinSize',
    'hintMisnapAxisAngle',
    'hintMisnapHeadOutside',
    'hintMisnapHeadSkewed',
    'hintMisnapHeadTooClose',
    'hintMisnapHeadTooFar',
    'hintMisnapReadyPose',
    'hintMisnapReadyPost',
    'hintMisnapSmile',
    'hintMisnapStayStill',
    'hintMisnapStopSmiling',
    'hintMisnapSuccess',
    'hintMitekErrorBusyBackground',
    'hintMitekErrorFocus',
    'hintMitekErrorFourCorner',
    'hintMitekErrorGlare',
    'hintMitekErrorHorizontalFill',
    'hintMitekErrorLowContrast',
    'hintMitekErrorMinPadding',
    'hintMitekErrorMrzMissing',
    'hintMitekErrorSkewAngle',
    'hintMitekErrorTooDark',
    'hintNoFaceFound',
    'hintDefault',
] as const;

export const FeedbackKeys = [
    'CORRUPT_IMAGE',
    'CV_NO_BARCODE_FOUND',
    'IMAGE_SMALLER_THAN_MIN_SIZE',
    'MISNAP_AXIS_ANGLE',
    'MISNAP_HEAD_OUTSIDE',
    'MISNAP_HEAD_SKEWED',
    'MISNAP_HEAD_TOO_CLOSE',
    'MISNAP_HEAD_TOO_FAR',
    'MISNAP_READY_POSE',
    'MISNAP_READY_POST',
    'MISNAP_SMILE',
    'MISNAP_STAY_STILL',
    'MISNAP_STOP_SMILING',
    'MISNAP_SUCCESS',
    'MITEK_ERROR_BUSY_BACKGROUND',
    'MITEK_ERROR_FOCUS',
    'MITEK_ERROR_FOUR_CORNER',
    'MITEK_ERROR_GLARE',
    'MITEK_ERROR_HORIZONTAL_FILL',
    'MITEK_ERROR_LOW_CONTRAST',
    'MITEK_ERROR_MIN_PADDING',
    'MITEK_ERROR_MRZ_MISSING',
    'MITEK_ERROR_SKEW_ANGLE',
    'MITEK_ERROR_TOO_DARK',
    'NO_FACE_FOUND',
    'default',
] as const;

type FeedbackMap = {
    [key in typeof FeedbackKeys[number]]?: Function | string;
};

export const HintMap: {
    [key in typeof FeedbackKeys[number]]: string;
} = {
    CORRUPT_IMAGE: 'hintCorruptImage',
    CV_NO_BARCODE_FOUND: 'hintCvNoBarcodeFound',
    IMAGE_SMALLER_THAN_MIN_SIZE: 'hintImageSmallerThanMinSize',
    MISNAP_AXIS_ANGLE: 'hintMisnapAxisAngle',
    MISNAP_HEAD_OUTSIDE: 'hintMisnapHeadOutside',
    MISNAP_HEAD_SKEWED: 'hintMisnapHeadSkewed',
    MISNAP_HEAD_TOO_CLOSE: 'hintMisnapHeadTooClose',
    MISNAP_HEAD_TOO_FAR: 'hintMisnapHeadTooFar',
    MISNAP_READY_POSE: 'hintMisnapReadyPose',
    MISNAP_READY_POST: 'hintMisnapReadyPost',
    MISNAP_SMILE: 'hintMisnapSmile',
    MISNAP_STAY_STILL: 'hintMisnapStayStill',
    MISNAP_STOP_SMILING: 'hintMisnapStopSmiling',
    MISNAP_SUCCESS: 'hintMisnapSuccess',
    MITEK_ERROR_BUSY_BACKGROUND: 'hintMitekErrorBusyBackground',
    MITEK_ERROR_FOCUS: 'hintMitekErrorFocus',
    MITEK_ERROR_FOUR_CORNER: 'hintMitekErrorFourCorner',
    MITEK_ERROR_GLARE: 'hintMitekErrorGlare',
    MITEK_ERROR_HORIZONTAL_FILL: 'hintMitekErrorHorizontalFill',
    MITEK_ERROR_LOW_CONTRAST: 'hintMitekErrorLowContrast',
    MITEK_ERROR_MIN_PADDING: 'hintMitekErrorMinPadding',
    MITEK_ERROR_MRZ_MISSING: 'hintMitekErrorMrzMissing',
    MITEK_ERROR_SKEW_ANGLE: 'hintMitekErrorSkewAngle',
    MITEK_ERROR_TOO_DARK: 'hintMitekErrorTooDark',
    NO_FACE_FOUND: 'hintNoFaceFound',
    default: 'hintDefault',
} as const;

export default FeedbackMap;